import { render, staticRenderFns } from "./workOrderTaglList.vue?vue&type=template&id=2e2b84ab&scoped=true"
import script from "./workOrderTaglList.vue?vue&type=script&lang=js"
export * from "./workOrderTaglList.vue?vue&type=script&lang=js"
import style0 from "./workOrderTaglList.vue?vue&type=style&index=0&id=2e2b84ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2b84ab",
  null
  
)

export default component.exports